module.exports = __webpack_public_path__ + "media/components/country-flag/static/cg-741b61ed74472c19683e2d04b15a574d.svg";